module.exports = __webpack_public_path__ + "img/logo1 (8).7942ceab.jpg";